<template>
  <div class="row m-0">
    <div>
      <div class="">
        <div
          class="error-message error-text"
          v-if="validateInput(error, 'nootptext', null)"
        >
          <div>Please enter otp</div>
        </div>
        <div class="0">
          <div class="pb-2 pt-2">
            <span class="text-message"
              >Please enter the OTP (One Time Password) sent to
            </span>
            <span
              v-if="validateInput(fetch_data, 'mobile', null)"
              class="verify-title"
              >{{ fetch_data.isdcode }}{{ fetch_data.mobile }}</span
            >
            <span class="verify-title pr-2" v-if="fetch_data.email">{{
              fetch_data.email
            }}</span>
          </div>

          <label
            :class="{
              'error-input': errorInput === true,
              'error-no-input': validateInput(error, 'nootptext', true),
            }"
            class="w-100 pure-material-textfield-outlined my-2"
          >
            <input
              @keyup.enter="verifyUser"
              placeholder=" "
              v-model="otp"
              v-on:focus="resetError"
              id="otp"
            />
            <span>Enter OTP</span>
          </label>

          <div class="pt-3 d-flex">
            <button
              class="btn-danger mdc-theme--primary-shape-bg w-100 go-back mr-2"
              name="SubmitLogin"
              type="submit"
              v-on:click="handleBack"
              id="backbtn"
            >
              Back
            </button>
            <button
              class="btn-danger mdc-theme--primary-shape-bg w-100"
              name="SubmitLogin"
              type="submit"
              id="submitOTP"
              v-on:click="verifyUser"
            >
              Verify
            </button>
          </div>

          <resend-otp
            :tokendata="accessInputToken"
            :typedata="tokenInputType"
            v-on:getRequest="otpRequest"
            id="resendOTPcomp"
          ></resend-otp>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Services from "../services";
import Validation from "./mixins/Validation";
import CountryCode from "./mixins/CountryCode";
import CommonCode from "./mixins/CommonCode";
import ResendOtp from "./ReSendOtp.vue";
import UserUtils from "./mixins/UserUtils";
import { EventBus } from "../events";
import * as Sentry from "@sentry/vue";

export default {
  mixins: [Validation, CountryCode, CommonCode, UserUtils],

  props: {
    auth: {
      type: Boolean,
    },

    hideChangeOption: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    // HeaderTitle,
    // ContentDescription,
    // Notification,
    ResendOtp,
  },

  data() {
    return {
      tokenInputType: null,
      accessInputToken: null,
      otp: null,
      requestId: null,
      errorStatusCode: null,
    };
  },

  methods: {
    otpRequest(data) {
      this.requestId = data;
    },

    goBack() {
      if (this.saved_timerInterval) clearInterval(this.saved_timerInterval);
      this.$router.push(
        { name: this.getGuestDefaultPage(), params: this.$route.params },
        () => {}
      );
    },

    pushOtpVerfiedcaptureEvents(response, eventCallBack) {
      let analyticsData = {};
      let identifyEventObj = {};
      if (response && response.data && response.data.user) {
        const { user } = response.data;
        analyticsData = {
          name: user.name,
          email: user.email,
          phoneNo: user.phone,
          customerId: user.customerId,
        };
        identifyEventObj = {
          customerId: user.customerId,
          otpVerified: 1,
        };
      }
      //reset lemniskCbExecuted flag if already set
      if (this.lemniskCbExecuted) this.lemniskCbExecuted = false;
      let backTo = window.localStorage.getItem("backTo");
      if (backTo && backTo.includes("/lead-quiz")) {
        let queryParams = backTo.split("?")[1];
        const urlParams = new URLSearchParams(queryParams);
        const leadId = urlParams.get("id");
        //send identify event also for otp verified scenario
        //so passing identifyEventObj as fourth param
        EventBus.$emit(
          "captureEvents",
          "accounts_lead-form:otp_verified",
          {
            ...analyticsData,
            leadId,
          },
          eventCallBack,
          identifyEventObj
        );
      } else {
        //send identify event also for otp verified scenario
        //so passing identifyEventObj as fourth param
        EventBus.$emit(
          "captureEvents",
          "accounts_login:otp_verified",
          analyticsData,
          eventCallBack,
          identifyEventObj
        );
      }
      //explicitly call our callback in case of lemnisk fails
      this.handleCallbackIfEventFails(
        eventCallBack,
        "callBackAfterOtpVerified"
      );
    },

    checkforNextStep(response) {
      /**redirect to signup page */
      const userData = this.$route.params;
      userData.back = "verify";
      this.$router.push({
        name: this.getSignUpPage(),
        params: userData,
        query: { login_challenge: this.$route.query.login_challenge },
      });
    },

    sendOTPVerificationEvent(eventName, extraData={}, eventCallBack, identifyEventObj) {
      const isPhoneOTPVerificationInitiated = this.fetch_data.type === "phone"
      EventBus.$emit(
        "captureEvents",
        eventName,
        {
          // TODO: add this  attribute to old events
          method: isPhoneOTPVerificationInitiated ? "phone" : "email",
          username: isPhoneOTPVerificationInitiated ? `${this.fetch_data.isdcode} ${this.fetch_data.username}` : this.fetch_data.username,
          ...extraData
        },
        eventCallBack,
        identifyEventObj
      );
    },

    handleBack() {
      EventBus.$emit("captureGAEvent", "verify_otp", { signin_method: 'BACK'});
      this.sendOTPVerificationEvent("accounts_signin:clicked_otp_back")
      this.back()
    },

    verifyUser() {
      EventBus.$emit("captureGAEvent", "verify_otp", { signin_method: 'VERIFY'});
      // event for otp verification initiated
      this.sendOTPVerificationEvent("accounts_signin:customer_submit-btn-clicked")
      /** Call verify otp API based on access token or direct username
       * if no otp provide will show error msg
       * else api call
       * based on api response:
       * isAdditionalInformationRequired:
       *      true => redirect to signup page
       *      false => login api call directly
       */

      this.error = {};

      if (!this.otp) {
        this.error.nootptext = true;
        return false;
      }

      if (this.saved_accessToken) {
        Services.validateUser(
          this.fetch_data,
          this.fetch_data.isdcode,
          this.otp,
          this.requestId,
          this.getTokenTypeValue(),
          this.saved_accessToken
        )
          .then((response) => {
            this.sendOTPVerificationEvent("accounts_signin:customer_signed-in", response)
            const callBackAfterOtpVerified = () => {
              this.lemniskCbExecuted = true;
              this.$router.push({ name: this.getAuthDefaultPage() }, () => {});
            };
            this.pushOtpVerfiedcaptureEvents(
              response,
              callBackAfterOtpVerified
            );
          })
          .catch((error) => {
            const analyticsData = {
              username: this.fetch_data.username,
            };
            this.sendOTPVerificationEvent("accounts_login:otp_verification_failed")
            this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
              msg: error.response.data.message,
              errorCode: error.response.status,
            });
            Sentry.withScope((scope) => {
              scope.setTag("pageUrl", window.location.href);
              scope.setTag("Application", "ACCOUNTS");
              Sentry.captureMessage(`ERROR AT LOGIN ${err}`, {
                level: "error",
              });
            });
          });
      } else {
        let payload = {
          otp: this.otp,
          request_id: this.requestId,
        };
        if (this.fetch_data.type == "phone") {
          payload["username"] =
            this.fetch_data.isdcode + this.fetch_data.username;
          payload["isdCode"] = this.fetch_data.isdcode;
        } else {
          payload["username"] = this.fetch_data.username;
        }
        Services.sendPayload(
          payload,
          "login",
          this.$route.query.login_challenge
        )
          .then((response) => {
            this.sendOTPVerificationEvent("accounts_signin:customer_signed-in", response)
            if (response.data.additionalAttributesRequired) {
              const callBackAfterOtpVerified = () => {
                this.lemniskCbExecuted = true;
              };
              this.pushOtpVerfiedcaptureEvents(
                response,
                callBackAfterOtpVerified
              );
              this.checkforNextStep(response);
            } else {
              if (response.data.additionalIdentityRequired) {
                let userData = this.$route.params;
                userData.requestId = this.requestId;
                //REDIRECT TO TAKE ADDITIONAL DETAILS
                this.$router.push({
                  name: "verify-additional-identity",
                  params: userData,
                  query: { login_challenge: this.$route.query.login_challenge },
                });
                this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
                  msg: null,
                  errorCode: 0,
                });

                const eventData = {
                  name: response.data && response.data.name,
                  email: response.data && response.data.email,
                  phoneNo: response.data && response.data.phone,
                  customerId: response.data && response.data.customerId,
                };
                this.sendOTPVerificationEvent("accounts_login:otp_verified", eventData)
              } else {
                const callBackAfterOtpVerified = () => {
                  this.lemniskCbExecuted = true;
                  this.windowRedirection(response.data.redirect_uri);
                };
                this.pushOtpVerfiedcaptureEvents(
                  response,
                  callBackAfterOtpVerified
                );
              }
            }
          })

          .catch((error) => {
            this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
              msg: error.response.data.message,
              errorCode: error.response.status,
            });
            this.sendOTPVerificationEvent("accounts_login:otp_verification_failed")
          });
      }
    },
  },

  beforeMount() {
    EventBus.$emit("showContent");
    this.tokenInputType = this.auth ? this.getTokenTypeValue() : null;
    this.accessInputToken = this.auth ? this.saved_accessToken : null;

    if (
      this.fetch_data.mobile ||
      this.fetch_data.email ||
      this.fetch_data.username
    ) {
      return true;
    } else {
      if (this.saved_accessToken) {
        this.userResponse = this.saved_userInfo;
        if (this.userResponse && this.userResponse.authList) {
          for (let i = 0; i < this.userResponse.authList.length; i++) {
            if (this.userResponse.authList[i]["type"] === "phone") {
              let parsePhone = this.parsePhonenumber(
                this.userResponse.authList[i]["username"]
              );
              this.fetch_data.mobile = parsePhone.phone_number;
              this.fetch_data.isdcode = parsePhone.isdcode;
            }
          }
        }

        if (!this.fetch_data.mobile) {
          let data = {};
          this.$router.push(
            { name: this.getAddMobileEntity(), params: data },
            () => {}
          );
        }
      } else {
        this.$router.push({ name: this.getGuestDefaultPage() }, () => {});
      }
    }
  },
  beforeDestroy() {
    if (this.saved_timerInterval) clearInterval(this.saved_timerInterval);
  },
};
</script>
<style scoped>
.verify-title {
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  line-height: 24px;
  font-weight: 500;
  color: #1a1a1a;
}
</style>